import { Form } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FiltersDrawer from '@/components/filters-drawer';
type DrawerFilterProps = {
  count: number;
  defaultValues: string[];
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (kinds?: string[]) => void;
};
type FormValues = {
  kinds: string[];
};
const KINDS = ['kyc', 'kyb', 'auth', 'document'] as const;
const DrawerFilter = ({
  count,
  defaultValues,
  isOpen,
  onOpenChange,
  onSubmit
}: DrawerFilterProps) => {
  const {
    t
  } = useTranslation('playbooks', {
    keyPrefix: 'table.filters.drawer'
  });
  const methods = useForm<FormValues>({
    defaultValues: {
      kinds: defaultValues
    }
  });
  const {
    handleSubmit,
    reset,
    watch
  } = methods;
  const kinds = watch('kinds');
  const handleOpenChange = (nextOpen: boolean) => {
    reset({
      kinds: defaultValues
    });
    onOpenChange(nextOpen);
  };
  const submit = handleSubmit(({
    kinds: kinds_0
  }) => onSubmit(kinds_0.length ? kinds_0 : undefined));
  return <FiltersDrawer count={count} open={isOpen} onOpenChange={handleOpenChange} onApply={submit} onClear={() => onSubmit()}>
      <FormProvider {...methods}>
        <form onSubmit={submit} className="flex flex-col">
          <FiltersDrawer.Section title={t($ => $.playbookType)} count={kinds.length} defaultOpen>
            <Form.CheckboxGroup<FormValues> name="kinds" options={KINDS.map(kind => ({
            label: t($_0 => $_0[kind]),
            value: kind
          }))} className="flex flex-col gap-2" />
          </FiltersDrawer.Section>
        </form>
      </FormProvider>
    </FiltersDrawer>;
};
export default DrawerFilter;